import { Badge, Card, MenuItem } from "@mui/material";
import { Grid2 } from "@mui/material";
import docRegister from 'src/assets/doctor-register.webp';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { TextField, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { Avatar } from "@mui/material";
import { CalendarMonthOutlined, CameraAlt } from "@mui/icons-material";
import { DialogContentText, } from "@mui/material";
import { useNavigate } from "react-router";
import { generateOTP, registerDoctor } from "src/services/registeration/registerationService";
import toast from "react-hot-toast";
import { MobileDatePicker } from "@mui/x-date-pickers";
import DailogPopup from "src/layouts/components/dailog";
import { Filter } from "bad-words";
import { generateotprequest } from "src/models/generateotp";


const filter = new Filter();

export const DoctorInfoPage = () => {
    return (
        <Grid2 container sx={{ bgcolor: 'grey.200' }}>
            <Grid2 size={{ xs: 12, md: 4, lg: 5 }} display={{ xs: 'none', md: 'flex' }} justifyContent={'center'} alignItems={'center'} >
                <img src={docRegister} alt={'doc'} style={{ objectFit: 'contain' }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 8, lg: 7 }} p={4}>
                <Card sx={{ borderRadius: 3, p: 2 }}>
                    <DoctorRegisterForm />
                </Card>
            </Grid2>
        </Grid2>
    )
}

const AvailabilityOptions = [
    { value: 'All hours', label: 'All hours' },
    { value: 'Business hours only', label: 'Business hours only' },
    { value: 'Afternoon only', label: 'Afternoon only' },
    { value: 'Weekends', label: 'Weekends' },
];

const HowDidYouKnowOptions = [
    { value: 'Internet search', label: 'Internet search' },
    { value: 'Word of mouth / Referral', label: 'Word of mouth / Referral' },
    { value: 'Advertising', label: 'Advertising' },
    { value: 'Others', label: 'Others' },
];

const schema = yup.object().shape({
    firstname: yup.string().matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed").required("First name is required").test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    lastname: yup.string().matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed").required("Last name is required").test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    ahpraregistrationNumber: yup.string().matches(/^[A-Za-z\d]+$/, "Only alphanumeric are allowed").required("Ahpra registration number is required"),
    ahpravalidUntilDate: yup.date().required("Ahpra validity date is required"),
    emailAddress: yup.string().email("Invalid email").matches(/^[^@]+@[^@]+\.[^@]+$/, 'Invalid Email').required("Email is required").test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    mobileNumber: yup
        .string()
        .required('Mobile number is required')
        .matches(
            /^(?:\+61\d{9}|0\d{9})$/,
            'Mobile number must start with +61 or 0 followed by 9 digits'
        )
        .test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    availability: yup
        .string()
        .oneOf(AvailabilityOptions.map((a) => a.value), 'Select a valid availability option')
        .required('Availability is required')
        .test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    sourceOfInformation: yup
        .string()
        .oneOf(
            HowDidYouKnowOptions.map((h) => h.value),
            'Select a valid option'
        )
        .required('This field is required')
        .test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
});

const Input = styled("input")({
    display: "none"
});

const RequiredLabel = (label: string) => (
    <span>
        {label} <span style={{ color: 'red' }}>*</span>
    </span>
);


const DoctorRegisterForm = () => {
    const { control, handleSubmit, formState: { errors }, getValues } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const [image, setImage] = useState<string | null>(null);
    const [otpDialogOpen, setOtpDialogOpen] = useState(false);
    const [otpUuid, setOtpUuid] = useState('');
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(90);
    const [timerActive, setTimerActive] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (otpDialogOpen) {
            setOtp('');
            setTimer(90);
            setTimerActive(true);
        }
    }, [otpDialogOpen]);

    const restartTimer = () => {
        setTimer(90);
        setTimerActive(true);
    };

    useEffect(() => {
        let interval: NodeJS.Timeout;

        if (timerActive) {
            interval = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setTimerActive(false); // Stop the timer
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [timerActive]);


    const onSubmit = async (data: any) => {
        const payload = {
            ...data,
            isDoctorRegistration: true
        };
        let otp = await generateOTP(payload);
        if (otp.ok) {
            setOtpUuid(otp.data.otpUuid);
            setOtpDialogOpen(true);
            restartTimer();
            setTimerActive(true);
        } else {
            toast.error(otp.message);
        }
    };

    const handleOtpSubmit = async () => {
        try {
            let data = getValues();
            if (data) {
                setLoading(true);
                const formData = new FormData();
                Object.entries({ ...data, otp, otpUuid }).forEach(([key, value]) => {
                    if (key === 'ahpravalidUntilDate' && value instanceof Date) {
                        formData.append(key, value.valueOf().toString());
                    } else if (value instanceof Date) {
                        formData.append(key, value.toISOString());
                    } else if (value !== null && value !== undefined) {
                        formData.append(key, String(value));
                    }
                });

                if (image) {
                    const response = await fetch(image);
                    const blob = await response.blob();
                    formData.append('image', blob, 'profile.jpg');
                }
                formData.append('createdDate', new Date().valueOf().toString());
                let register = await registerDoctor(formData);
                if (register.ok) {
                    setOtpDialogOpen(false);
                    navigate('/register/confirmation/doctor')
                } else {
                    toast.error(register.message)
                }
            }

        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        const data = getValues();

        const payload: generateotprequest = {
            emailAddress: data.emailAddress,
            mobileNumber: data.mobileNumber,
            firstname: data.firstname,
            lastname: data.lastname,
            otpUuid: ''
        };

        try {
            const otpResponse = await generateOTP(payload);
            if (otpResponse.ok) {
                setOtpUuid(otpResponse.data.otpUuid);
                toast.success("OTP resent successfully!");
                restartTimer();
            } else {
                toast.error(otpResponse.message || "Failed to resend OTP.");
            }
        } catch (error) {
            toast.error("An error occurred while resending OTP.");
        }
    };


    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container spacing={2}>

                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="firstname"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField {...field} slotProps={{
                                    inputLabel: {
                                        shrink: Boolean(field.value)
                                    }
                                }} label={RequiredLabel("First Name")} fullWidth error={!!fieldState.error} helperText={fieldState.error?.message} />
                            )}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="lastname"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField slotProps={{
                                    inputLabel: {
                                        shrink: Boolean(field.value)
                                    }
                                }} {...field} label={RequiredLabel("Last Name")} fullWidth error={!!fieldState.error} helperText={fieldState.error?.message} />
                            )}
                        />
                    </Grid2>


                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="emailAddress"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField slotProps={{
                                    inputLabel: {
                                        shrink: Boolean(field.value)
                                    }
                                }} {...field} label={RequiredLabel("Email")} fullWidth error={!!fieldState.error} helperText={fieldState.error?.message} />
                            )}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="mobileNumber"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    type="text"
                                    inputProps={{ inputMode: 'tel' }}
                                    label={RequiredLabel("Phone Number")}
                                    fullWidth
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    value={
                                        field.value?.startsWith('+61')
                                            ? field.value.replace(/^\+61(\d{3})(\d{3})(\d{3})$/, '+61 $1 $2 $3')
                                            : field.value?.startsWith('0')
                                                ? field.value.replace(/^0(\d{3})(\d{3})(\d{3})$/, '0$1 $2 $3')
                                                : field.value || ''
                                    }
                                    onChange={(e) => {
                                        let input = e.target.value.replace(/[^\d+]/g, '');

                                        // Handle if starts with 0 or +61
                                        if (input.startsWith('0')) {
                                            input = input.slice(0, 10); // 0 followed by 9 digits
                                        } else if (input.startsWith('+61')) {
                                            input = input.slice(0, 12); // +61 followed by 9 digits
                                        }

                                        field.onChange(input);
                                    }}
                                    slotProps={{
                                        inputLabel: { shrink: Boolean(field.value) }
                                    }}
                                />
                            )}
                        />
                    </Grid2>


                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="ahpraregistrationNumber"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField slotProps={{
                                    inputLabel: {
                                        shrink: Boolean(field.value)
                                    }
                                }} {...field} label={RequiredLabel("Ahpra Registration Number")} fullWidth error={!!fieldState.error} helperText={fieldState.error?.message} />
                            )}
                        />
                    </Grid2>
                                       <Grid2 size={{ xs: 12, md: 6 }}>
                                           <Controller
                                               name="ahpravalidUntilDate"
                                               control={control}
                                               render={({ field, fieldState }) => (
                                                   <MobileDatePicker format="dd/MM/yyyy" disableHighlightToday
                                                       disablePast
                                                       {...field} label={RequiredLabel("Ahpra Validity Until")} slotProps={{
                                                           textField: {
                                                               fullWidth: true,
                                                               error: !!errors.ahpravalidUntilDate,
                                                               helperText: errors.ahpravalidUntilDate?.message,
                                                               slotProps: {
                                                                   inputLabel: {
                                                                       shrink: true
                                                                   },
                                                                   input: {
                                                                       endAdornment: <CalendarMonthOutlined />
                                                                   }
                                                               }
                                                           }
                                                       }} />
                                               )}
                                           />
                   
                                       </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="availability"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    select
                                    label={RequiredLabel("Availability")}
                                    fullWidth
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    slotProps={{
                                        inputLabel: { shrink: Boolean(field.value) },
                                        input: { sx: { textAlign: 'left' } },
                                    }}
                                >
                                    {AvailabilityOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Controller
                            name="sourceOfInformation"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    select
                                    label={RequiredLabel("How did you get to know about Prime Health")}
                                    fullWidth
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    slotProps={{
                                        inputLabel: { shrink: Boolean(field.value) },
                                        input: { sx: { textAlign: 'left' } },
                                    }}
                                >
                                    {HowDidYouKnowOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        />
                    </Grid2>

                    <Typography variant="body2" color="textSecondary"> Note : Fields marked with an asterisk (*) are required.</Typography>
                    <Grid2 size={{ xs: 12 }} textAlign={'center'}>
                        <Button type="submit" variant="contained" color="primary">
                            Register
                        </Button>
                    </Grid2>
                </Grid2>
            </form>
            <DailogPopup open={otpDialogOpen}
                onCancel={() => setOtpDialogOpen(false)}
                onSubmit={handleOtpSubmit}
                loading={loading}
                title={"Enter OTP"}
                disableSubmit={timer === 0}
                resendButton={
                    timer === 0 ? (
                        <Button
                            onClick={handleResendOtp}
                            variant="contained"
                            color="primary"
                        >
                            Resend OTP
                        </Button>
                    ) : null
                }
            >
                <DialogContentText>
                    Please enter the 4-digit OTP sent to your registered phone.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="OTP"
                    type="text"
                    slotProps={{
                        inputLabel: {
                            shrink: Boolean(otp)
                        }
                    }}
                    fullWidth
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    disabled={timer === 0}
                />
                <Typography
                    variant="caption"
                    color={timer === 0 ? 'error' : 'textSecondary'}
                    sx={{ mt: 1 }}
                >
                    {timer > 0
                        ? `OTP expires in ${timer} second${timer === 1 ? '' : 's'}`
                        : 'OTP expired. Click "Resend OTP" to get a new one.'}
                </Typography>

            </DailogPopup>
        </>
    );
};


export default DoctorInfoPage;